import { SERVICE_PLANS } from '../../api/endpoints';
import { baseApi, listTags } from './baseApi';

const multipart =
  typeof FormData !== 'undefined'
    ? { headers: { 'Content-Type': 'multipart/form-data' } }
    : {};

export const servicePlansApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    // GET ALL SERVICE PLANS
    getServicePlans: build.query({
      query: (params = {}) => ({ url: SERVICE_PLANS.LIST, method: 'GET', params }),
      providesTags: (result) => listTags('ServicePlan', result),
    }),
    getServicePlanById: build.query({
      query: (arg) => {
        const id = typeof arg === 'object' && arg != null ? arg.id : arg;
        const params =
          typeof arg === 'object' && arg != null ? arg.params : undefined;
        return { url: SERVICE_PLANS.BY_ID(id), method: 'GET', params };
      },
      providesTags: (_r, _e, arg) => [
        {
          type: 'ServicePlan',
          id: typeof arg === 'object' && arg != null ? arg.id : arg,
        },
      ],
    }),
    createServicePlan: build.mutation({
      query: (payload) => {
        const isFormData =
          typeof FormData !== 'undefined' && payload instanceof FormData;
        return {
          url: SERVICE_PLANS.CREATE,
          method: 'POST',
          data: payload,
          ...(isFormData ? multipart : {}),
        };
      },
      invalidatesTags: [{ type: 'ServicePlan', id: 'LIST' }],
    }),
    updateServicePlan: build.mutation({
      query: ({ id, data: updateData, params, ...rest }) => {
        const payload = updateData ?? rest;
        const isFormData =
          typeof FormData !== 'undefined' && payload instanceof FormData;
        return {
          url: SERVICE_PLANS.BY_ID(id),
          method: 'PUT',
          data: payload,
          params,
          ...(isFormData ? multipart : {}),
        };
      },
      invalidatesTags: (_r, _e, { id }) => [
        { type: 'ServicePlan', id },
        { type: 'ServicePlan', id: 'LIST' },
      ],
    }),
    deleteServicePlan: build.mutation({
      query: (id) => ({ url: SERVICE_PLANS.BY_ID(id), method: 'DELETE' }),
      invalidatesTags: (_r, _e, id) => [
        { type: 'ServicePlan', id },
        { type: 'ServicePlan', id: 'LIST' },
      ],
    }),
  }),
});

export const {
  useGetServicePlansQuery,
  useLazyGetServicePlansQuery,
  useGetServicePlanByIdQuery,
  useLazyGetServicePlanByIdQuery,
  useCreateServicePlanMutation,
  useUpdateServicePlanMutation,
  useDeleteServicePlanMutation,
} = servicePlansApi;
